'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './banner.component';
import dynamic from 'next/dynamic';

const DynamicBannerComponent: ComponentType<Props> = dynamic(() => import('./banner.component'));

export default DynamicBannerComponent;

export function calculateBannerPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 150 },
    { sinceWidth: 425, height: 200 },
    { sinceWidth: 768, height: 270 },
    { sinceWidth: 1024, height: 325 },
    { sinceWidth: 1442, height: 437 }
  ];

  return {
    heightSinceWidth
  };
}
